if (!customElements.get('card-swiper')) {
  class CardSwiper extends HTMLElement {
    constructor() {
      super();
      this.track = null;
      this.dots = [];
      this.slideCount = 0;
      this.currentIndex = 0;
      this.hasTrackedSwipe = false;
      this.scrollTimeout = null;
      this.listening = false;
      this.onScroll = () => {
        this.handleScroll();
      };
    }

    connectedCallback() {
      this.bind();
      if (!this.listening) {
        requestAnimationFrame(() => {
          if (this.isConnected) this.bind();
        });
      }
    }

    disconnectedCallback() {
      if (this.track && this.listening) {
        this.track.removeEventListener('scroll', this.onScroll);
      }
      this.listening = false;
      if (this.scrollTimeout) {
        clearTimeout(this.scrollTimeout);
        this.scrollTimeout = null;
      }
    }

    bind() {
      this.track = this.querySelector('.card-swiper__track');
      const card = this.closest('.card-wrapper');
      const dotsRoot = card ? card.querySelector('.card-swiper__dots') : null;
      this.dots = dotsRoot ? dotsRoot.querySelectorAll('.card-swiper__dot') : [];
      this.slideCount = this.dots.length;

      if (!this.track || this.slideCount < 2 || this.listening) return;

      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      this.listening = true;
    }

    handleScroll() {
      if (this.scrollTimeout) {
        clearTimeout(this.scrollTimeout);
      }
      this.scrollTimeout = setTimeout(() => {
        this.updateCurrentIndex();
      }, 50);
    }

    updateCurrentIndex() {
      if (!this.track) return;

      const slideWidth = this.track.clientWidth;
      if (!slideWidth) return;

      const newIndex = Math.round(this.track.scrollLeft / slideWidth);

      if (newIndex !== this.currentIndex && newIndex >= 0 && newIndex < this.slideCount) {
        this.currentIndex = newIndex;
        this.updateDots();

        if (newIndex > 0 && !this.hasTrackedSwipe) {
          this.trackSwipeEvent();
        }
      }
    }

    updateDots() {
      this.dots.forEach((dot, index) => {
        dot.classList.toggle('is-active', index === this.currentIndex);
      });
    }

    trackSwipeEvent() {
      this.hasTrackedSwipe = true;
      if (typeof clarity !== 'function') return;
      try {
        clarity('event', 'card_swipe');
      } catch (error) {
        return;
      }
    }
  }

  customElements.define('card-swiper', CardSwiper);
}
